import {
  faArrowDown,
  faArrowUp,
  faMagnifyingGlass,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Form, InputGroup, Table } from "react-bootstrap";
import "./Instruments.css";
import {
  getAllCompanyChartData,
  getAllCompanyMarketPrice,
} from "../../../../utils/apis/graph/graph";
import { Context } from "../../../../utils/context";
import InstrumentSocket from "./InstrumentSocket";
import { io } from "socket.io-client";

const Instruments = ({
  onClose,
  setCompanyId,
  setCompanyName,
  priceHistory,
  setPriceHistory,
  latestCloses,
  setLatestCloses,
  getPriceHistory,
  latestBaseCloses,
  setLatestBaseCloses,
  isMobile,
}) => {

  const { IMG_URL, setHeaderCompanyName } = useContext(Context);

  return (
    <section className="Instruments">
      <div className="heading_part">
        <p className="heading_name">Crypto</p>
        {isMobile && (
          <div className="img_holder" onClick={onClose}>
            <img src="/assets/images/trade/close.png" className="close_img" />
          </div>
        )}
      </div>

      <div className="inputs_div">
        <div className="first_input_div">
          <div className="left_input">
            <InputGroup className="gray_input_group">
              <Form.Control
                placeholder="Search"
                type="text"
                className="file_input"
                onChange={(e) => getPriceHistory(e.target.value)}
              />
            </InputGroup>
          </div>
        </div>
      </div>

      <div className="market_table_wrapper">
        <Table responsive className="market_table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Price</th>
              <th>Signal</th>
            </tr>
          </thead>
          <tbody>
            {priceHistory?.map((item, index) => (
              <InstrumentSocket
                key={item.id}
                item={item}
                index={index}
                onClose={onClose}
                latestClose={latestCloses[item.id]}
                latestBaseCloses={latestBaseCloses[item.id]}
                onSelect={(id, name) => {
                  setCompanyId(id);
                  setCompanyName(name);
                  setHeaderCompanyName(name);
                }}
              />
            ))}
          </tbody>
        </Table>
      </div>
    </section>
  );
};

export default Instruments;
